<script setup lang="ts">
import { computed, defineProps, withDefaults } from 'vue';

const props = withDefaults(
  defineProps<{
    shadow: boolean;
    active: boolean;
    class?: string;
    action?: (event?: MouseEvent) => void;
  }>(),
  {
    active: false,
    shadow: false,
    class: undefined,
    action: undefined,
  }
);

const classes = computed<string>(() => {
  return `${props.shadow ? 'hover:shadow-s-hover' : ''} ${props.active ? 'bg-gray-300 dark:bg-gray-750 dark:stroke-gray-500' : 'hover:bg-gray-250 dark:hover:bg-gray-750'} ${props.class}`;
});

function click(event: MouseEvent) {
  event.preventDefault();
  props.action?.(event);
}
</script>

<template>
  <button
    :class="classes"
    class="tppr-button__animation flex h-l w-l items-center justify-center rounded-6 stroke-black active:bg-gray-350 dark:stroke-gray-500 dark:hover:stroke-gray-500 dark:active:bg-gray-850"
    @click="click"
  >
    <slot></slot>
  </button>
</template>
